import React from "react";

function Adverstment() {
  return (
    <div className="adverstment">
      <div className="container">
        <div className="adverstment-one adverstment-card">
          <h3>SEASONAL SALE</h3>
          <span>Winter Collection -50% Off</span>
        </div>
        <div className="adverstment-two adverstment-card">
          <h3>NEW FOOTWEAR COLLECTION</h3>
          <span>Spring/Summer 2022</span>
        </div>
        <div className="adverstment-three adverstment-card">
          <h3>T-SHIRTS</h3>
          <span>Newly Trendly T-shirts</span>
        </div>
      </div>
    </div>
  );
}

export default Adverstment;
